import React, { Component } from "react";
import Slider from "react-slick";

export default class MultipleItems extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
    };
    return (
      <Slider {...settings}>
        <div>
          <footer className="footer">
            <p>meuapp.com.br/</p>
            <span></span>
          </footer>
        </div>
        <div>
          <footer className="footer">
            <p>meuapp.com.br/</p>
          </footer>
        </div>
        <div>
          <footer className="footer">
            <p>meuapp.com.br/</p>
            <span></span>
          </footer>
        </div>
        <div>
          <footer className="footer">
            <p>meuapp.com.br/</p>
            <span></span>
          </footer>
        </div>
        <div>
          <footer className="footer">
            <p>meuapp.com.br/</p>
            <span></span>
          </footer>
        </div>
      </Slider>
    );
  }
}
